import { createI18n } from 'vue-i18n'
import koCommon from '~/locales/ko/common.json'
import enCommon from '~/locales/en/common.json'

const COOKIE_NAME = 'i18n_redirected'

function readLocaleFromCookie(): 'ko' | 'en' {
    if (typeof document === 'undefined') return 'ko'
    const match = document.cookie.match(new RegExp('(?:^|; )' + COOKIE_NAME + '=([^;]+)'))
    const value = match ? decodeURIComponent(match[1]) : null
    return value === 'en' ? 'en' : 'ko'
}

export default defineNuxtPlugin(({ vueApp }) => {
    const initialLocale = readLocaleFromCookie()

    const i18n = createI18n({
        legacy: false,
        globalInjection: true,
        locale: initialLocale,
        fallbackLocale: 'ko',
        messages: {
            ko: koCommon,
            en: enCommon
        }
    })

    vueApp.use(i18n)

    if (typeof document !== 'undefined') {
        document.documentElement.setAttribute('lang', initialLocale)
    }
})
